import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../../modules/reports/general/scheduleReportActions'
import * as api from '../../../api/reports/general/scheduleReport'

function* scheduleReportGetJobList(action) {
  try {
    const payload = yield call(api.getJobList, action.filters)
    yield put({ type: constants.SCHEDULE_REPORT_GET_JOB_LIST.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.SCHEDULE_REPORT_GET_JOB_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* scheduleReportGetFullReport(action) {
  try {
    const payload = yield call(api.getFullReport, action.filters)
    yield put({ type: constants.SCHEDULE_REPORT_GET_FULL_REPORT.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.SCHEDULE_REPORT_GET_FULL_REPORT.FAILED,
      message: e.message || e
    })
  }
}

/**
 * Saga
 */
function* watchScheduleReportGetJobList() {
  yield takeLatest(constants.SCHEDULE_REPORT_GET_JOB_LIST.ACTION, scheduleReportGetJobList)
}

function* watchScheduleReportGetFullReport() {
  yield takeLatest(constants.SCHEDULE_REPORT_GET_FULL_REPORT.ACTION, scheduleReportGetFullReport)
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([fork(watchScheduleReportGetJobList), fork(watchScheduleReportGetFullReport)])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/reports/general/scheduleReportSaga.js